module.exports = __webpack_public_path__ + "994f3ddfaf72c00cc267b1c44f6f0176.png";